import { createApp } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import App from './App.vue'

import { sys } from '@/system/SystemProvider'
const pinia = createPinia()
setActivePinia(pinia)
const Vue = createApp(App).use(pinia)

/* Vue.config.warnHandler = (e) => {
  if (e.indexOf('Extraneous non-props attributes') === -1) {
    console.log(e)
  }
} */
sys().start()
Vue.mount('#app')
